import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiNotification } from '@taiga-ui/core';

@Component({
  selector: 'app-forbidden-page',
  imports: [TuiNotification],
  templateUrl: './forbidden-page.component.html',
  styleUrl: './forbidden-page.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenPageComponent {}
